/**
 * BaseTools
 *
 * */
import store from "@/store"
import StackDrag from "@/utils/stack_drag_class/mobile"
class CornerstoneMZYL {
  constructor() {
    this._rootVue = null
    this._enableDom = []
    this.doubletapStatus = true
    this.viewportActive = null
    this.pathname = null
    this.seriesIndex = 0
  }

  static getInstance() {
    if (!CornerstoneMZYL.instance) {
      CornerstoneMZYL.instance = new CornerstoneMZYL()
      return CornerstoneMZYL.instance
    }
    return CornerstoneMZYL.instance
  }

  get rootVue() {
    return this._rootVue
  }

  setSeriesIndex(index) {
    this.seriesIndex = index
  }

  setViewportActive(viewport) {
    this.viewportActive = viewport
  }

  /**
   * @param {refName} ref名称
   * @param {seriesIndex} 序列下标
   * @param {thumbnail} 缩略图
   * @return
   */
  DCMRender(refName, seriesIndex, thumbnail) {
    if (!refName) {
      refName = this.viewportActive
    }
    const _this = this
    // 获取状态管理信息
    const pathname = location.pathname.split("/")[1]
    this.pathname = pathname
    const seriesDataList = store.getters[pathname]
    // 点击缩略图更新viewport
    if (thumbnail) {
      const _firstDcmFilePaths = seriesDataList[seriesIndex].getDcmFilePath
      //Dicom 加载进度监听
      StackDrag.mixin(this._rootVue)
      StackDrag.newImageIdIndexToSliceIndex = 0;
      StackDrag.init()

      cornerstone
        .loadAndCacheImage(seriesDataList[seriesIndex].getDcmFilePath[0])
        .then((image) => {
          cornerstone.displayImage(refName, image)
          cornerstone.reset(refName)
          cornerstoneTools.addStackStateManager(refName, ["stack"])
          cornerstoneTools.addToolState(refName, "stack", {
            currentImageIdIndex: 0,
            imageIds: seriesDataList[seriesIndex].getDcmFilePath
          })
        })

      return
      _firstDcmFilePaths.forEach((imageId, index) => {
        cornerstone
          .loadAndCacheImage(imageId)
          .then(() => {
            seriesDataList[seriesIndex].percentage =
              seriesDataList[seriesIndex].percentage != undefined
                ? seriesDataList[seriesIndex].percentage + 1
                : 1
          })
          .catch((err) => {
            store.dispatch("errorInfo", {
              0: seriesIndex
            })
          })
      })
      return
    }
    if (
      cornerstone.getEnabledElement(refName) &&
      cornerstone.getImage(refName)
    ) {
      cornerstone.resize(refName)
      return
    }
    cornerstone.enable(refName)
    // console.log(seriesDataList[seriesIndex]);
    if (seriesDataList[seriesIndex]) {
      //Dicom 加载进度监听
      StackDrag.mixin(this._rootVue)
      StackDrag.init()
      cornerstone
        .loadAndCacheImage(seriesDataList[seriesIndex].getDcmFilePath[0])
        .then((image) => {
          cornerstone.displayImage(refName, image)
          cornerstone.reset(refName)
          cornerstoneTools.addStackStateManager(refName, ["stack"])
          cornerstoneTools.addToolState(refName, "stack", {
            currentImageIdIndex: 0,
            imageIds: seriesDataList[seriesIndex].getDcmFilePath
          })
        })
        .catch((err) => {
          store.dispatch("errorInfo", {
            0: seriesIndex
          })
        })
    }
    // 绑定监听事件
    _this._addEventListener(refName)
  }

  rotateViewport() {
    const viewport = cornerstone.getViewport(this.viewportActive)
    viewport.rotation += 90
    cornerstone.setViewport(this.viewportActive, viewport)
  }

  scaleViewport(scale) {
    const viewport = cornerstone.getViewport(this.viewportActive)
    if (scale === 1.5) {
      viewport.scale = scale
      cornerstone.setViewport(this.viewportActive, viewport)
    } else {
      cornerstone.reset(this.viewportActive)
    }
  }

  reset() {
    cornerstone.reset(this.viewportActive)
  }

  _addEventListener(refName) {
    const _this = this
    this._removeEventListener(refName)
    // refName.addEventListener(
    //   "cornerstonetoolsdoubletap",
    //   _this.onDoubletap.bind(this)
    // )
    refName.addEventListener(
      "cornerstonetoolsdoubletap",
      _this.onDoubletap.bind(this)
    )

    refName.addEventListener(
      "cornerstonetoolstouchstart",
      _this.onTouchstart.bind(this)
    )

    refName.addEventListener(
      "cornerstoneimagerendered",
      _this.onImageRendered.bind(this)
    )
  }

  _removeEventListener(refName) {
    const _this = this
    refName.removeEventListener("cornerstonetoolsdoubletap", _this.onDoubletap)
    refName.removeEventListener(
      "cornerstonetoolstouchstart",
      _this.onTouchstart
    )

    refName.removeEventListener(
      "cornerstoneimagerendered",
      _this.onImageRendered
    )
  }

  onDoubletap() {
    const useMPR = store.getters["useMPR"]
    if (useMPR) {
      store.dispatch("updateUseMPR", false)
      store.dispatch("setViewportList", [
        {
          ac: true,
          style: {
            width: "100%",
            height: "100%"
          }
        }
      ])
      const viewports = this.getDomArray("viewportItem")
      const seriesDataList = store.getters.imageBrowsing[this.seriesIndex]

      // 设置翻页高亮

      viewports.forEach((element) => {
        // cornerstone.reset(element,true);
        cornerstone
          .loadAndCacheImage(seriesDataList.getDcmFilePath[0])
          .then((image) => {
            cornerstone.displayImage(element, image)
            cornerstone.updateImage(element)
            // cornerstone.reset(element,true);
            cornerstoneTools.setToolActive("StackScroll", {
              mouseButtonMask: 1
            })
            cornerstoneTools.setToolActive("StackScrollMouseWheel", {})
            cornerstoneTools.addStackStateManager(element, ["stack"])
            cornerstoneTools.addToolState(element, "stack", {
              currentImageIdIndex: 0,
              imageIds: seriesDataList.getDcmFilePath
            })
          })
      })
      this._rootVue.$nextTick(() => {
        viewports.forEach((element) => {
          cornerstone.resize(element)
        })
      })
      return
    } else {
      // this.doubletapStatus = !this.doubletapStatus
      // this.scaleViewport(this.doubletapStatus ? 1 : 1.5)
    }
  }

  onTouchstart(ev) {
    this.setViewportActive(ev.target)
    const { index } = ev.target.dataset
    const viewport = store.getters.imageBrowsingViewportList[index]
    // console.log(imageBrowsingViewportList)
    // 更新选中的状态
    store.dispatch("updateViewportStatus", { viewport, index })
    // 解除播放
    const playClipData = cornerstoneTools.getToolState(
      this.viewportActive,
      "playClip"
    )
    if (
      playClipData &&
      playClipData.data &&
      playClipData.data.length > 0 &&
      playClipData.data[0].intervalId !== undefined
    ) {
      cornerstoneTools.stopClip(this.viewportActive)
    }
  }

  onImageRendered(ev) {
    function _getImageIndex(imagePlaneModuleCustom, imagePlaneModule, dataSet) {
      if (imagePlaneModuleCustom) {
        return imagePlaneModuleCustom.imageIndex
      }
      if (imagePlaneModule && imagePlaneModule.imageIndex) {
        return imagePlaneModule.imageIndex
      }
      if (dataSet) {
        return dataSet.intString("x00200013")
      }
    }

    const viewport = cornerstone.getViewport(ev.target)
    const image = cornerstone.getImage(ev.target)
    //如果已经点击过跳窗
    if (JSON.parse(sessionStorage.getItem("wwccActive"))) {
      let selfViewport = {
        windowWidth: Math.round(viewport.voi.windowWidth),
        windowCenter: Math.round(viewport.voi.windowCenter)
      }
      sessionStorage.setItem("wwwcStatus", JSON.stringify(selfViewport))
    }
    var _cornerstoneWADOImage2 = cornerstoneWADOImageLoader.wadouri,
      parseImageId = _cornerstoneWADOImage2.parseImageId,
      dataSetCacheManager = _cornerstoneWADOImage2.dataSetCacheManager

    var parsedImageId = parseImageId(image.imageId)
    var dataSet = dataSetCacheManager.get(parsedImageId.url)
    // 获取自定义的meta
    var imagePlaneModuleCustom = cornerstone.metaData.get(
      "imagePlaneModuleCustom",
      image.imageId
    )

    let imagePlaneModule =
      cornerstone.metaData.get("imagePlaneModule", image.imageId) || {}
    let generalSeriesModule =
      cornerstone.metaData.get("generalSeriesModule", image.imageId) || {}

    // const byteArray = image.data.byteArray
    // var dataSet = dicomParser.parseDicom(byteArray /*, options */)
    // viewport 的下标
    const { index } = ev.target.dataset
    const viewportData = store.getters.imageBrowsingViewportList[index]
    const seriesData = store.getters.imageBrowsing
    viewportData.topLeft = store.getters.fourCornerMarkDataParse.topLeft
    viewportData.topRight = store.getters.fourCornerMarkDataParse.topRight

    const c = `窗位：${Math.round(viewport.voi.windowCenter)}`
    const w = `窗宽：${Math.round(viewport.voi.windowWidth)}`
    viewportData.bottomLeft = [c, w]
    const count = seriesData[this.seriesIndex].getDcmFilePath.length
    const imgstr = `img :${_getImageIndex(
      imagePlaneModuleCustom,
      imagePlaneModule,
      dataSet
    )} / ${count}`
    viewportData.bottomRight = [imgstr]

    // store.dispatch("updateViewportMeta", { viewportData, index })
  }

  // 重绘布局
  updataLayout(viewports) {
    viewports.forEach((ele, seriesIndex) => {
      if (cornerstone.getEnabledElement(ele)) {
        cornerstone.resize(ele)
      } else {
        this.DCMRender(ele, seriesIndex)
      }
    })
  }

  WwwcPreset(value) {
    const viewport = cornerstone.getViewport(this.viewportActive)
    if (value.width === "--") {
      const image = cornerstone.getImage(this.viewportActive)
      const defaultViewport = cornerstone.getDefaultViewportForImage(
        this.viewportActive,
        image
      )
      viewport.voi.windowWidth = defaultViewport.voi.windowWidth
      viewport.voi.windowCenter = defaultViewport.voi.windowCenter
      viewport.invert = false
      cornerstone.setViewport(this.viewportActive, viewport)
      return
    }
    viewport.voi = {
      windowWidth: Number(value.width),
      windowCenter: Number(value.center)
    }
    cornerstone.setViewport(this.viewportActive, viewport)
  }

  mixin(rootVue) {
    this._rootVue = rootVue
  }
  /**
   * @param {String} ref名称
   * @return { dom } 返回匹配的dom节点
   */
  getDomArray(refName) {
    if (
      refName &&
      Object.prototype.toString.call(refName) === "[object String]"
    ) {
      return this._rootVue.$refs[refName]
    }
  }
}

export default CornerstoneMZYL.getInstance()
